import styled from 'styled-components';
import { IoClose } from 'react-icons/io5';
import { FiPlus } from 'react-icons/fi';
import Button from '../Button';

export const Wrapper = styled.div`
  width: 100%;
  height: 100%;
`;

export const ImageAndRemoveWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: flex-end;
  position: relative;
`;

export const MainImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
  &:hover {
    cursor: pointer;
  }
`;

export const RemoveImageBtn = styled(Button).attrs({
  wrapperStyle: {
    width: '30px',
    height: '30px',
    marginTop: '10px',
    marginRight: '15px',
    position: 'absolute',
  },
  type: 'rounded',
  icon: IoClose,
  iconProps: {
    color: 'white',
    size: '18px',
  },
})``;

export const NoImageContainer = styled.div`
  width: 100%;
  height: 100%;
  border: darkGrey 1px solid;
  background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-itemrs: center;
  &:hover {
    background-color: whiteSmoke;
    cursor: pointer;
  }
`;

export const PlusSymbol = styled(FiPlus)`
  color: darkGrey;
  align-self: center;
  width: ${({ size }) => size || '100px'};
  height: ${({ size }) => size || '100px'};
`;

export const SelectImageTxt = styled.p`
  text-align: center;
  font-size: 1.25rem;
  margin-top: 0.5rem;
  color: darkGrey;
`;

export const ProgressBarContainer = styled.div`
  width: ${(props) => props.containerStyle.width};
  height: ${(props) => props.containerStyle.height};
  background-color: white;
  padding: 60px;
  align-items: center;
  justify-content: center;
  display: flex;

  svg {
    height: 100%;
  }
`;

export const PuffLoaderContainer = styled.div`
  width: ${(props) => props.containerStyle.width};
  height: ${(props) => props.containerStyle.height};
  background-color: white;
  align-items: center;
  justify-content: center;
  display: flex;
`;
